import React, { FC } from 'react'

import Chart from 'src/components/Chart'

const ThirdRow: FC = () => {
  return <Chart />
}

export default ThirdRow
